import { all, put, call, takeLatest, takeEvery } from "redux-saga/effects";
import {
  getCCFPSummary,
  getCCFPLandingInfo,
  getCCFPPassbook,
  withdrawCFFPMoney,
} from "../services/api";
import { actions } from "../reducers/ccfpReducer";
import {
  FETCH_CCFP_SUMMARY_REQ,
  WITHDRAW_CCFP_MONEY,
  FETCH_CCFP_LANDING_PAGE,
  FETCH_PASSBOOK,
  FETCH_CCFP_LANDING_PAGE_SUCCESS,
} from "../reducers/actionTypes";

function* getCCFPSummarySaga() {
  try {
    const { data } = yield call(getCCFPSummary);
    yield put(actions.setCCFPSummary(data));
  } catch (e) {
    yield put(actions.fetchCCFPFailed(e));
  }
}

function* withdrawMoneySaga({ payload }) {
  try {
    const { data } = yield call(withdrawCFFPMoney, payload);
    yield put(actions.withdrawMoneySuccess(data));

    // refresh other information
    yield put({ type: FETCH_CCFP_SUMMARY_REQ });
    yield put({ type: FETCH_CCFP_LANDING_PAGE });
    yield put({ type: FETCH_PASSBOOK });
  } catch (err) {
    yield put(actions.withdrawMoneyFailed(err));

    // refresh other information
    yield put({ type: FETCH_CCFP_SUMMARY_REQ });
    yield put({ type: FETCH_CCFP_LANDING_PAGE });
    yield put({ type: FETCH_PASSBOOK });
  }
}

function* landingPageSaga() {
  try {
    const { data } = yield call(getCCFPLandingInfo);
    if (data) {
      yield put({ type: FETCH_CCFP_LANDING_PAGE_SUCCESS, payload: { data } });
    }
  } catch (error) {
    // yield put(actions.fetchLandingError(error));
  }
}

function* fetchPassbookSaga() {
  try {
    const { data } = yield call(getCCFPPassbook, {});
    yield put(actions.fetchPassbookSuccess(data));
  } catch (error) {
    yield put(actions.fetchPassbookError(error));
  }
}

export default function* root() {
  yield all([takeLatest(FETCH_CCFP_SUMMARY_REQ, getCCFPSummarySaga)]);
  yield all([takeLatest(WITHDRAW_CCFP_MONEY, withdrawMoneySaga)]);
  yield all([takeLatest(FETCH_CCFP_LANDING_PAGE, landingPageSaga)]);
  yield all([takeLatest(FETCH_PASSBOOK, fetchPassbookSaga)]);
}
